import { z } from 'zod';

function nullable<Z extends z.ZodType>(
  zodEffect: Z,
): z.ZodCatch<z.ZodUnion<readonly [Z, z.ZodNull]>> {
  return z.union([zodEffect, z.null()]).catch(null);
}

function array<ZodType extends z.ZodType>(schema: ZodType) {
  return z.array(schema);
}

function apiResponse<ZodType extends z.ZodType>(schema: ZodType) {
  return z.object({
    errors: z.array(
      z.object({ code: nullable(z.string()), message: nullable(z.string()) }),
    ),
    hasSucceeded: z.boolean(),
    data: nullable(schema),
  });
}
const dateDtoSchema = z.object({
  year: z.number(),
  monthNumber: z.number(),
  dayOfMonth: z.number(),
  weekNumber: z.number(),
  dayOfWeek: z.number(),
});

const databaseDtoSchema = z.object({
  id: z.string(),
  isActive: z.boolean(),
  createdAt: z.string().datetime({ offset: true }),
  createdBy: nullable(z.string()),
  updatedAt: nullable(z.string().datetime({ offset: true })),
  updatedBy: nullable(z.string()),
});

const namedDtoSchema = z.object({
  name: nullable(z.string()),
  description: nullable(z.string()),
});

export {
  apiResponse,
  array,
  databaseDtoSchema,
  dateDtoSchema,
  namedDtoSchema,
  nullable,
};
